import { Controller } from "@hotwired/stimulus"

// 아이디어 인터뷰 "질문 준비하기" 폼 submit 직전에
// KlavyAgent 채팅창이 localStorage에 저장한 선택 모델을 hidden input으로 주입한다.
// 이렇게 하면 우측에서 고른 모델(GLM-5.1, gpt-5.4, gemini-2.5-pro 등)로
// 좌측 설문 스키마도 동일하게 생성된다.
export default class extends Controller {
  static values = { storageKey: { type: String, default: "baAgent-model" } }

  connect() {
    this.element.addEventListener("submit", this._ensureModel, { capture: true })
  }

  disconnect() {
    this.element.removeEventListener("submit", this._ensureModel, { capture: true })
  }

  _ensureModel = () => {
    const keys = [
      this.storageKeyValue,
      "baAgent_planning-workspace-designer-model",
      "baAgent-model",
    ].filter((key, index, arr) => key && arr.indexOf(key) === index)

    let model = null
    try {
      for (const key of keys) {
        model = localStorage.getItem(key)
        if (model) break
      }
    } catch (_) {}
    if (!model) return

    let hidden = this.element.querySelector('input[name="model"]')
    if (!hidden) {
      hidden = document.createElement("input")
      hidden.type = "hidden"
      hidden.name = "model"
      this.element.appendChild(hidden)
    }
    hidden.value = model
  }
}
